import { render } from "./Share_Deposits.vue?vue&type=template&id=e00d9e24"
import script from "./Share_Deposits.vue?vue&type=script&lang=js"
export * from "./Share_Deposits.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__